import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Element } from "react-scroll";
import { Link } from "react-router-dom";
import "./Home.css";
import Projects from "./Projects";

function Home() {
  return (
    <div>
      {/* Hero with Skills */}
      <Element
        name="home"
        className="section bg-dark text-light d-flex align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Container className="text-center">
          <h1 className="fw-bold display-4">Hi, I'm Donovan ⚡</h1>
          <p className="lead text-warning">
            Software Engineer • Fullstack Developer
          </p>

          {/* Skills with logos */}
          <Row className="mt-4 justify-content-center g-4">
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-react-original colored fs-1"></i>
                <p className="mt-2">React</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-nodejs-plain colored fs-1"></i>
                <p className="mt-2">Node.js</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-mongodb-plain colored fs-1"></i>
                <p className="mt-2">MongoDB</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-express-original text-light fs-1"></i>
                <p className="mt-2">Express</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-css3-plain colored fs-1"></i>
                <p className="mt-2">CSS</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-html5-plain colored fs-1"></i>
                <p className="mt-2">HTML</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-javascript-plain colored fs-1"></i>
                <p className="mt-2">JS</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-github-original fs-1"></i>
                <p className="mt-2">Github</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-git-plain colored fs-1"></i>
                <p className="mt-2">Git</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-reactrouter-plain colored fs-1"></i>
                <p className="mt-2">React Router</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-redux-original colored fs-1"></i>
                <p className="mt-2">Redux</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-reactbootstrap-plain colored fs-1"></i>
                <p className="mt-2">reactBootstrap</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-vercel-original fs-1"></i>
                <p className="mt-2">Vercel</p>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="skill-icon">
                <i className="devicon-netlify-plain colored fs-1"></i>
                <p className="mt-2">Netlify</p>
              </div>
            </Col>
          </Row>
        </Container>
      </Element>

      {/* Projects */}
      {/* <Element name="projects" className="section bg-light py-5 text-center">
       <Container>
        <Link to={`/projects`}>
         <Button variant="warning">
           View Projects
         </Button>
        </Link>
       </Container>
      </Element> */}

      {/* Contact */}
       <Element name="contact" className="section bg-dark text-light py-5">
        <Container className="text-center">
          <h2 className="fw-bold mb-4">Contact Me</h2>
          <div className="d-flex justify-content-center gap-4 fs-2">
            <a
              href="https://www.linkedin.com/in/donovan-monteiro-5131b1148/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-light contact-icon"
            >
              <i className="bi bi-linkedin"></i>
            </a>
            <a
              href="https://github.com/don0716"
              target="_blank"
              rel="noopener noreferrer"
              className="text-light contact-icon"
            >
              <i className="bi bi-github"></i>
            </a> 
            {/* <a
              href="https://instagram.com/yourprofile"
              target="_blank"
              rel="noopener noreferrer"
              className="text-light contact-icon"
            >
              <i className="bi bi-instagram"></i>
            </a>  */}
            <a href="donmonteiro16@gmail.com" className="text-light contact-icon">
              <i className="bi bi-envelope-fill"></i>
            </a>
          </div>
        </Container> 
       </Element> 
    </div>
  );
}

export default Home;
